import Bugsnag from "@bugsnag/js";
import { getQueryParams } from "@/utils/httpRequest";
import { lenderService } from "@/modules/contacts/features/lender/store/services/lender-service";
import { LENDER_SERVICE_TAG } from "@/modules/contacts/features/lender/utils/lender-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";

const getLenders = lenderService.injectEndpoints({
  endpoints: builder => ({
    getLenders: builder.query({
      query: ({ params }) => `lenders?${getQueryParams(params)}`,
      providesTags: result =>
        result
          ? [
              ...result.records.map(({ lenderId }) => ({ type: LENDER_SERVICE_TAG, lenderId })),
              { type: LENDER_SERVICE_TAG, id: LIST_SERVICE_TAG },
            ]
          : [{ type: LENDER_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted({ params, setParams }, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (!data.records.length && params.page > 1) {
            setParams(prevParams => ({ ...prevParams, page: prevParams.page - 1 }));
          }
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetLendersQuery } = getLenders;

